import React from 'react';
import { RenderElementProps } from 'slate-react';

export const ParagraphElement: React.FC<RenderElementProps> = ({
  attributes,
  children,
}) => {
  return <div {...attributes}>{children}</div>;
};
